import {
  RegressionType,
  RegressionConfig,
  RegressionParameterConstraintType,
  RegressionParameterName,
} from './RegressionTypes';

export const R_SQUARED = 'R\u00B2';

export const REGRESSION_TYPE_TO_READABLE: {[key in RegressionType]: string} = {
  [RegressionType.LINEAR]: 'Linear',
  [RegressionType.LOGISTIC]: '4-parameter logistic',
  [RegressionType.QUADRATIC]: 'Quaddratic',
};

const REGRESSION_TYPE_TO_REQUIRED_PARAMETERS_IN_ORDER: {
  [key in RegressionType]: Array<RegressionParameterName>;
} = {
  [RegressionType.LINEAR]: [],
  [RegressionType.LOGISTIC]: [
    RegressionParameterName.MIN,
    RegressionParameterName.MAX,
    RegressionParameterName.IC50,
    RegressionParameterName.HILL_SLOPE,
  ],
  [RegressionType.QUADRATIC]: [],
};

function buildDefaultRegressionConfig(regressionType: RegressionType): RegressionConfig {
  return {
    regressionType,
    version: 1,
    parameterCustomizations: REGRESSION_TYPE_TO_REQUIRED_PARAMETERS_IN_ORDER[regressionType].map(
      (parameterName) => ({
        name: parameterName,
        initialValue: null,
        constraint: {type: RegressionParameterConstraintType.NONE},
      })
    ),
  };
}

// Keep in sync with regression_config_constants.py
export const REGRESSION_TYPE_TO_DEFAULT_CONFIG: {[key in RegressionType]: RegressionConfig} = {
  [RegressionType.LINEAR]: buildDefaultRegressionConfig(RegressionType.LINEAR),
  [RegressionType.LOGISTIC]: buildDefaultRegressionConfig(RegressionType.LOGISTIC),
  [RegressionType.QUADRATIC]: buildDefaultRegressionConfig(RegressionType.QUADRATIC),
};
